// pages
import Dashboard from "../components/dashboard";
import Splunk from "../components/splunk/Splunk";
import Tour from "../components/tour";
import AllAgentLogs from "../components/agentLogs/AllLogs";
// routers
import { orgRouter, tenantRouter, settingsRouter, workloadIdentityRouter, serviceAccountRouter } from "./childRouters/simpleRouter";
import pamRouter from "./childRouters/pamRouter";
import ServiceCredentials from "../components/serviceAccount/ServiceCredentials";
import windowsRouter from "./childRouters/windowsRouter";
import ditRouter from "./childRouters/ditRouter";
import onboardRouter from "./childRouters/onboardRouter";
import directoryRouter from "./childRouters/directoryRouter";
import endUserRouter from "./childRouters/endUserRouter";

const appRoutes = [
  { path: "", element: <Dashboard /> },
  { path: "tour", element: <Tour /> },
  { path: "splunk", element: <Splunk /> },
  { path: "logs", element: <AllAgentLogs /> },
  { path: "serviceCredentials", element: <ServiceCredentials /> },
  {
    path: "tenant/users/*", children: endUserRouter
  },
  // Tenent router
  { path: "tenant/*", children: tenantRouter },
  // Org
  { path: "org/*", children: orgRouter },
  // Setting
  { path: "setting/*", children: settingsRouter },
  // PAM
  { path: "pam/*", children: pamRouter },
  // WINDOWS
  { path: "windows/*", children: windowsRouter },
  // DIT
  { path: "dit/*", children: ditRouter },
  // ONBOARD
  { path: "onboard/*", children: onboardRouter },
  // WorkloadIdentity
  { path: "workloadIdentity/*", children: workloadIdentityRouter },
  // SERVICE Account
  { path: "serviceAccount/*", children: serviceAccountRouter },
  // Directory
  { path: "directory/*", children: directoryRouter },
  // EndUser
  // { path: "endUser", children: endUserRouter }

];

export default appRoutes;
